export default {
  // 清算单
  settlementBillList: 'Settlement Bill List',
  weeklyDocument: 'Weekly Document',
  monthlyDocument: 'Monthly Document',
  week: 'Week',
  Monthly: 'Monthly',
  period: 'Period',
  salesRegion: 'Sales Region',
  storeMode: 'Store Mode',
  settlementDate: 'Settlement Date',
  details: 'Details',
  actuallyPaid: 'Actually Paid',
  commissionType: 'Commission Type',
  platformLogisticsCharge: 'Platform Logistics Charge',
  coins: 'Coins',
  platformVoucher: 'Platform Voucher',
  storeVoucher: 'Store Voucher',
  paymentCharge: 'Payment Charge',
  tradeCharge: 'Trade Charge',
  commission: 'Commission',
  operationCharge: 'Operation Charge',
  refundInAftersales: 'Refund in Aftersales',
  punishments: 'Penalties',
  logisticsCharge: 'Logistics Charge',
  settlementResult: 'Settlement Result',
  settlementBillDocument: 'Settlement Bill Document',
  settlementBillNo: 'Settlement Bill No.',
  category: 'Category',
  commissionRate: 'Commission Rate',
  storeRate: 'Store Rate',
  viewTheSettings: 'View The Settings',
  storeConfirmStatus: 'Store Confirm Status',
  platformConfirmStatus: 'Platform Confirm Status',
  summaryInformationOfTheDocument: 'Summary information of the document',
  postageUserPaid: 'Postage User Paid',
  actuallyUserPaidTotal: 'Actually User Paid Total',
  coinsRedeem: 'Coins Redeem',
  voucherRedeemPlatform: 'Voucher Redeem (Platform)',
  voucherRedeemStore: 'Voucher Redeem (Store)',
  platformDeductionSummary: 'Platform deduction summary',
  platformPayForCoins: 'Platform Pay for Coins',
  platformPayForVoucherPlatform: 'Platform Pay for Voucher (Platform)',
  aftersalesSummary: 'Aftersales Summary',
  aftersalesCharge: 'Aftersales charge',
  settlementResults: 'Settlement Results',
  toBeSettledAmount: 'To be settled Amount',
  refundInAftersalesData: 'Refund in aftersales',
  aftersalesInformationInThisPeriod: 'Aftersales Information in this period',
  refund: 'Refund',
  records: ' records',
  exportRefundDetails: 'Export Refund Details',
  correctionInfo: 'Correction Info',
  correctionAmount: 'Correction Amount',
  addtionalDescr: 'Additional Descr',
  attached: 'Attached',
  salesOrdersIncluded: 'Sales orders included',
  orderID: 'Order No.',
  platform: 'Platform',
  storeNumber: 'Store#',
  store: 'Store',
  itemTotal: 'Item Total',
  commissionStandard: 'Commission Base Value',
  userPaid: 'User Paid',
  postageSettledTo: 'Postage settled to',
  postage: 'Postage',
  postageDiscount: 'Postage Discount',
  voucherPlatform: 'Voucher(P)',
  voucherStore: 'Voucher(S)',
  itemDiscount: 'Item Discount',
  logisticsType: 'Logistics Type',
  deliveryType: 'Delivery Type',
  paymentType: 'Payment Type',
  customerID: 'CustomerID',
  warehouseID: 'WarehouseID',
  orderTime: 'Order Time',
  completeTime: 'Complete Time',
  storeType1: '1P',
  storeType2: '3P',
  storeType3: 'Kili Shop',
  storeType4: 'Agent Sale',
  detailTip: 'The current function is in the testing period and the data has not yet been verified. The financial settlement data shall prevail.',
  show: 'Show',
  hide: 'Hide',
  thereAre: 'There are ',
  recordsNum: ' records',
  systemThe: 'System Confirm the Bill on ',
  automaticlly: ' Automaticlly',
  commistionType: 'Commission Type',
  operationLog: 'Settlement Bill Operation Log',
  success: 'successfully',
  invoiceQuery: 'Invoice query',
  sendConfirmationReceipt: 'Send confirmation receipt',
  invoiceGeneration: 'Invoice generation',
  storeConfirmsInvoice: 'Store confirms invoice',
  platformFinanceConfirmedInvoice: 'Platform Finance confirmed invoice',
  systemAutomaticallyConfirmedInvoice: 'System automatically confirmed invoice',
  platformRevisesInvoice: 'Platform revises invoice',
  storeQueries: 'Store queries',
  platformSuspends: 'Platform suspended',
  pendingSellerConfirmation: 'Pending seller confirmation',
  systemConfirmed: 'System confirmed',
  platformFinanceConfirmed: 'Platform finance confirmed',
  sellerSuspended: 'Platform suspended',
  pendingPlatformConfirmation: 'Pending platform confirmation',
  operate: 'Operate'
}
